import { useCallback, useState } from 'react';
export const useHoveredState = ({ onPointerEnter, onPointerLeave, }) => {
    const [hovered, setHovered] = useState(false);
    const handlePointerEnter = useCallback((event) => {
        setHovered(true);
        if (onPointerEnter) {
            onPointerEnter(event);
        }
    }, [onPointerEnter]);
    const handlePointerLeave = useCallback((event) => {
        setHovered(false);
        if (onPointerLeave) {
            onPointerLeave(event);
        }
    }, [onPointerLeave]);
    return {
        hovered,
        onPointerEnter: handlePointerEnter,
        onPointerLeave: handlePointerLeave,
    };
};
//# sourceMappingURL=use-hovered-state.js.map